import { buildGeneratedInvoiceUrl } from "./invoiceRowLinks";

const columns = [
  ["Deposit invoice #", (row) => `DEP #${row.id ?? ""}`],
  ["Invoice ID", (row) => row.id],
  ["Sales order #", (row) => row.orderId],
  ["Customer", (row) => row.customerName || row._displayName || ""],
  ["Status", (row) => row.invoiceStatus || row.paymentStatus || ""],
  ["Invoice date", (row) => row.invoiceDate ? new Date(row.invoiceDate).toLocaleDateString("en-CA") : ""],
  ["Amount", (row) => row.amount ?? ""],
  ["Currency", (row) => row.currency || "CAD"],
  ["Invoice URL", (row) => buildGeneratedInvoiceUrl(row) ? `${window.location.origin}${buildGeneratedInvoiceUrl(row)}` : ""],
];

const csvCell = (value) => `"${String(value ?? "").replace(/"/g, '""')}"`;
export const makeDepositRegisterCsv = (rows) => [
  columns.map(([header]) => csvCell(header)).join(","),
  ...rows.map((row) => columns.map(([, value]) => csvCell(value(row))).join(",")),
].join("\r\n");

export const downloadDepositRegisterCsv = (rows) => {
  const blob = new Blob(["\uFEFF", makeDepositRegisterCsv(rows)], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `deposit-invoices-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
};

const htmlEscape = (value) => String(value ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

const invoiceColumns = [
  ["Invoice #", (row) => `INV #${row.id ?? ""}`],
  ...columns.slice(1, -1),
];

const printRegister = (rows, { title, countLabel, columns: registerColumns }) => {
  // Open synchronously in response to the click, so pop-up blockers do not
  // interfere. No window features: browsers normally open this as a full tab.
  const tab = window.open("", "_blank");
  if (!tab) {
    window.alert("Please allow pop-ups to print this register.");
    return;
  }
  tab.opener = null;
  const table = `<table><thead><tr>${registerColumns.map(([label]) => `<th>${htmlEscape(label)}</th>`).join("")}</tr></thead><tbody>${rows.map((row) => `<tr>${registerColumns.map(([, value]) => `<td>${htmlEscape(value(row))}</td>`).join("")}</tr>`).join("")}</tbody></table>`;
  const markup = `<!doctype html><html><head><meta charset="utf-8"><title>${htmlEscape(title)}</title><style>body{font:12px Arial,sans-serif;margin:24px;color:#222}table{border-collapse:collapse;width:100%}th,td{border:1px solid #ddd;padding:7px;text-align:left}th{background:#eee}h1{font-size:20px}@page{size:landscape}@media print{thead{display:table-header-group}tr{break-inside:avoid}}</style></head><body><h1>${htmlEscape(title)}</h1><p>${rows.length} ${htmlEscape(countLabel)}</p>${table}</body></html>`;
  tab.document.open();
  tab.document.write(markup);
  tab.document.close();
  tab.focus();
  // Printing before the newly written document finishes loading can result
  // in an empty print preview. The load handler also handles slow browsers.
  const printWhenReady = () => {
    if (tab.closed) return;
    tab.requestAnimationFrame(() => tab.requestAnimationFrame(() => tab.print()));
  };
  if (tab.document.readyState === "complete") {
    printWhenReady();
  } else {
    tab.addEventListener("load", printWhenReady, { once: true });
  }
};

export const printDepositRegister = (rows) =>
  printRegister(rows, { title: "Deposit Invoice Register", countLabel: "deposit invoices", columns: columns.slice(0, -1) });

export const printInvoiceRegister = (rows) =>
  printRegister(rows, { title: "Invoice Register", countLabel: "invoices", columns: invoiceColumns });
